/**
 * Pure gallery stream-URL *formatters* — no axios, no auth, no cache.
 *
 * This module owns the single definition of the production fallback stream
 * URL shape:
 *   /api/auth/gallery/media/stream?key=<enc>&access_token=<tok>   (token)
 *   /api/auth/gallery/media/stream?key=<enc>                       (fetch/Bearer)
 *
 * It is imported by both src/utils/galleryContent.js (the consumer bridge) and
 * src/utils/studioMediaApi.js so the shape is defined exactly once. The
 * same-origin, no-auth dev shape (/api/gallery/media/stream?key=…) is owned by
 * the Unified ContentService (namespaceConfig.gallery.buildStreamUrl) and exposed
 * via galleryContent.js.
 */

function streamApiBase() {
  return (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
}

function normalizeKey(key) {
  return String(key || '').replace(/^\/+/, '').trim();
}

/**
 * Authenticated fallback stream URL (access_token as query param).
 * Matches the legacy studioMediaApi.buildGalleryMediaStreamUrls output.
 */
export function buildGalleryStreamUrlWithToken(key, token) {
  const k = normalizeKey(key);
  const params = new URLSearchParams({ key: k, access_token: token });
  return `${streamApiBase()}/auth/gallery/media/stream?${params.toString()}`;
}

/**
 * Stream URL for fetch() with an Authorization header (no access_token param).
 * Matches the legacy studioMediaApi.buildGalleryMediaStreamFetchUrls output.
 */
export function buildGalleryStreamFetchUrl(key) {
  const k = normalizeKey(key);
  const params = new URLSearchParams({ key: k });
  return `${streamApiBase()}/auth/gallery/media/stream?${params.toString()}`;
}
